import * as types from './mutation-types'

export const getSummaryInfo = ({commit}, payload) =>{
    commit(types.SUMMARY_INFO_REQUEST);
    //api call when needed
    const response = {
        facility: {
            name: 'Denver',
            address: '145 Milk rd',
        },
        count: {
            total: 3470,
            strains: 4,
            zones: 8,
            canopy: 12000,
        },
        yield: {
            nextDays:{
                planted: 20,
                harvested: 14
            },
            wholeYear: {
                planted: 230,
                harvested: 400
            }
        },
        tasks:{
            cloning: 30,
            transplants: 1,
            harvest: 2
        }
    }
    if(!response.error){
        commit(types.SUMMARY_INFO_SUCCESS, response)

    }else{
        commit(types.SUMMARY_INFO_FAILURE, response.error)
    }
}

export const getRacks = ({commit}, payload) => {
    commit(types.GET_RACKS_REQUEST);
    //api call here
    const response = {
        areas: [
            {
                name: 'Room 1 - Floor 1',
                racks: [{
                    id: 1,
                    name: 'R1C1',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'OJ Kush - Day 38',
                    temperature: 22,
                    humidity: 82,
                    co2: 800,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                },
                {
                    id: 2,
                    name: 'R1C2',
                    location: 'R2C2',
                    topShelfBasin: 'AK-47 - Day 34',
                    bottomShelfBasin: 'AK-47 - Day 34',
                    temperature: 23,
                    humidity: 83,
                    co2: 934,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                },
                {
                    id: 3,
                    name: 'R1C3',
                    location: 'R3C2',
                    topShelfBasin: 'Purple Haze - Day 104',
                    bottomShelfBasin: 'Purple Haze - Day 104',
                    temperature: 21,
                    humidity: 85,
                    co2: 826,
                    status: 'Error',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                },
                {
                    id: 4,
                    name: 'R1C4',
                    location: 'R4C2',
                    topShelfBasin: 'OJ Kush - Day 12',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 81,
                    co2: 801,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                },
                {
                    id: 5,
                    name: 'R1C5',
                    location: 'R5C2',
                    topShelfBasin: 'OJ Kush - Day 12',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 79,
                    co2: 802,
                    status: 'Warning',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                },
                {
                    id: 6,
                    name: 'R1C6',
                    location: 'R6C2',
                    topShelfBasin: 'OJ Kush - Day 12',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 21,
                    humidity: 82,
                    co2: 803,
                    status: 'Warning',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                }]
            },
            {
                name: 'Room 2 - Floor 2',
                racks: [{
                    id: 7,
                    name: 'R1C2',
                    location: 'R1C2',
                    topShelfBasin: 'Purple Haze - Day 38',
                    bottomShelfBasin: 'OJ Kush - Day 38',
                    temperature: 22,
                    humidity: 82,
                    co2: 800,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                },
                {
                    id: 8,
                    name: 'R1C2',
                    location: 'R2C2',
                    topShelfBasin: 'AK 47 - Day 42',
                    bottomShelfBasin: 'AK 47 - Day 34',
                    temperature: 23,
                    humidity: 83,
                    co2: 934,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                },
                {
                    id: 9,
                    name: 'R1C3',
                    location: 'R3C2',
                    topShelfBasin: 'Purple Haze - Day 104',
                    bottomShelfBasin: 'Purple Haze - Day 104',
                    temperature: 21,
                    humidity: 85,
                    co2: 826,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                },
                {
                    id: 10,
                    name: 'R1C4',
                    location: 'R3C2',
                    topShelfBasin: 'Gorilla Glue - Day 12',
                    bottomShelfBasin: 'Gorilla Glue - Day 12',
                    temperature: 22,
                    humidity: 81,
                    co2: 801,
                    status: 'Warning',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                },
                {
                    id: 11,
                    name: 'R1C5',
                    location: 'R5C2',
                    topShelfBasin: 'Gorilla Glue - Day 12',
                    bottomShelfBasin: 'Gorilla Glue - Day 12',
                    temperature: 22,
                    humidity: 79,
                    co2: 802,
                    status: 'Warning',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                },
                {
                    id: 12,
                    name: 'R1C6',
                    location: 'R6C2',
                    topShelfBasin: 'OJ Kush - Day 12',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 21,
                    humidity: 82,
                    co2: 803,
                    status: 'Error',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23'
                }]
            }
        ]
    }

    if(!response.error){
        commit(types.GET_RACKS_SUCCESS, response);
    }else{
        commit(types.GET_RACKS_FAILURE, response.error)
    }
}

export const getRack = ({commit}, rackId) => {
    commit(types.GET_RACK_REQUEST);
    const racks = [
        {
                    id: 1,
                    name: 'R1C1',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 2,
                    name: 'R1C2',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 3,
                    name: 'R1C3',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Error',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 4,
                    name: 'R1C2',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 5,
                    name: 'R1C2',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Warning',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 6,
                    name: 'R1C2',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Warning',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 7,
                    name: 'R1C2',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 8,
                    name: 'R1C2',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 9,
                    name: 'R1C2',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Healthy',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 10,
                    name: 'R1C2',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Warning',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 11,
                    name: 'R1C2',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Warning',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 12,
                    name: 'R1C2',
                    location: 'R1C2',
                    topShelfBasin: 'OJ Kush - Day 38',
                    bottomShelfBasin: 'AK 47 - Day 10',
                    temperature: 22,
                    humidity: 82,
                    co2: 80,
                    status: 'Error',
                    ipAddress: '127.0.0.1',
                    buildNumber: '23',
                    boardNumber: '123-123-123-123',
                    dateInstalled: '09/03/2000',
                    lastCheckin: '01/01/2017',
                    uptime: '23',
                    grower: 'MMJ',
                    facility: 'Denver',
                    address: '145 Milk Rd',
                    plantCount: 60,
                    strain: [
                        {
                            type: 'Purple Haze',
                            amount: 30
                        },
                        {
                            type: 'OJ Kush',
                            amount: 30
                        }
                    ],
                    lightsTop:{
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    lightsBottom: {
                        on: '11:00am',
                        off: '11:00pm'
                    },
                    harvestDay: '12.12.17 (38 Days)',
                    basins: [
                        {
                            basin: 'top',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        },
                        {
                            basin: 'bottom',
                            strain: 'OJ Kush',
                            plantPhase: 'Vegetation',
                            nextEvent: 'Prune (2 days)',
                            plantAge: 86,
                            daysToHarvest: 36,
                            plants: [
                                {
                                    plantId: '0192',
                                    location: 'R1C1',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C2',
                                    linerage: 'OJK M1',
                                    gender: 'Male',
                                    origin: 'Seed',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                },
                                {
                                    plantId: '0192',
                                    location: 'R1C3',
                                    linerage: 'OJK M1',
                                    gender: 'Female',
                                    origin: 'Clone',
                                    potentialBreeding: true,
                                    barcode: '123456',
                                    note: 'note'
                                }
                            ]
                        }
                    ]
                }
    ];
    const response = racks.find((rack) => {
        return rack.id === parseInt(rackId)
    });
    if(!response.error){
        commit(types.GET_RACK_SUCCESS, response);
    }else{
        commit(types.GET_RACK_FAILURE, response.error)
    }
}